import React, { useEffect, useCallback, useState } from "react";
import Avatar1 from "../../assets/images/avatar1.svg";
import Avatar2 from "../../assets/images/avatar2.svg";
import Avatar3 from "../../assets/images/avatar3.svg";
import Avatar4 from "../../assets/images/avatar4.svg";
import "./styles/testimonials.css";

const cardItems = [
  {
    id: 1,
    image: Avatar1,
    title: "Anonymous",
    copy: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus sit amet dui scelerisque, tempus dui non, blandit nulla. Etiam sed interdum est.",
  },
  {
    id: 2,
    image: Avatar3,
    title: "Eren Yegar",
    copy: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
  },
  {
    id: 3,
    image: Avatar2,
    title: "Mikasa Akarmen",
    copy: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus sit amet dui scelerisque, tempus dui non, blandit nulla.",
  },
  {
    id: 4,
    image: Avatar4,
    title: "Tanjiro",
    copy: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
  },
];

function determineClasses(indexes, cardIndex) {
  if (indexes.currentIndex === cardIndex) {
    return "active";
  } else if (indexes.nextIndex === cardIndex) {
    return "next";
  } else if (indexes.previousIndex === cardIndex) {
    return "prev";
  }
  return "inactive";
}

const Testemonials = () => {
  const [indexes, setIndexes] = useState({
    previousIndex: 0,
    currentIndex: 0,
    nextIndex: 1,
  });

  const handleCardTransition = useCallback(() => {
    if (indexes.currentIndex >= cardItems.length - 1) {
      setIndexes({
        previousIndex: cardItems.length - 1,
        currentIndex: 0,
        nextIndex: 1,
      });
    } else {
      setIndexes((prevState) => ({
        previousIndex: prevState.currentIndex,
        currentIndex: prevState.currentIndex + 1,
        nextIndex:
          prevState.currentIndex + 2 === cardItems.length
            ? 0
            : prevState.currentIndex + 2,
      }));
    }
  }, [indexes.currentIndex]);

  useEffect(() => {
    const transitionInterval = setInterval(() => {
      handleCardTransition();
    }, 4000);

    return () => clearInterval(transitionInterval);
  }, [handleCardTransition, indexes]);

  return (
    <div className="container" style={{ backgroundColor: "white" }}>
      <h1 style={{ textAlign: "center", paddingTop: "1rem" }}>
        What They Are Saying
      </h1>
      <ul className="card-carousel">
        {cardItems.map((card, index) => (
          <li
            key={card.id}
            className={`card ${determineClasses(indexes, index)}`}
          >
            <img style={{ height: "10vh" }} src={card.image} alt="" />
            <h2>{card.title}</h2>
            <p>{card.copy}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Testemonials;
